import React, { useContext, useMemo, useCallback } from "react";
import { useForm } from "react-final-form";
import { Options } from "ui/Form/Element/Select";
import { IntlContext } from "context";

export interface FilterActionsProps {
    onSelectAll?: () => void;
    onUnselectAll?: () => void;
    filterName: string;
    options: Options[];
    id?: string;
}

const FilterActions: React.FC<FilterActionsProps> = ({ onSelectAll, onUnselectAll, filterName, options, id }) => {
    const intl = useContext(IntlContext);
    const { change } = useForm();
    const allValues: any[] = useMemo(() => {
        return options.reduce((memo: any[], option: Options) => {
            memo.push("" + option.value);
            return memo;
        }, []);
    }, [options]);

    const handleOnSelectAll = useCallback(() => {
        change(filterName, allValues);
        onSelectAll && onSelectAll();
    }, [onSelectAll, filterName, change, allValues]);

    const handleOnUnselectAll = useCallback(() => {
        change(filterName, []);
        onUnselectAll && onUnselectAll();
    }, [onUnselectAll, filterName, change]);

    return (
        <div style={{ display: "flex" }}>
            <div>
                <button
                    type="button"
                    className="cta--link"
                    id={id}
                    onClick={handleOnSelectAll}
                    title={intl.formatMessage("stats.filters.select.all")}
                >
                    {intl.formatMessage("stats.filters.select.all")}
                </button>
            </div>
            <div style={{ flex: "1 0 auto", textAlign: "right" }}>
                <button
                    type="button"
                    className="cta--link"
                    onClick={handleOnUnselectAll}
                    title={intl.formatMessage("stats.filters.unselect.all")}
                >
                    {intl.formatMessage("stats.filters.unselect.all")}
                </button>
            </div>
        </div>
    );
};

export default FilterActions;
